import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import { AlertsPageConfigKeyEnum } from "@pages/alerts/components/alerts-page/alerts-page-configs";
import { AlertsPageComponent } from "@pages/alerts/components/alerts-page/alerts-page.component";

export function getAlertsRoutes(): Route[] {
  return [
    {
      path: 'alerts',
      title: 'Alerts',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      children: [
        {
          path: '',
          redirectTo: 'all',
          pathMatch: 'full'
        },
        {
          title: 'Inbox',
          path: 'inbox',
          component: AlertsPageComponent,
          data: {
            key: AlertsPageConfigKeyEnum.Inbox
          }
        },
        {
          title: 'All',
          path: 'all',
          component: AlertsPageComponent,
          data: {
            key: AlertsPageConfigKeyEnum.All
          }
        },
        {
          title: 'Required',
          path: 'required',
          component: AlertsPageComponent,
          data: {
            key: AlertsPageConfigKeyEnum.Required
          },
        },
        {
          title: 'Postponed',
          path: 'postponed',
          component: AlertsPageComponent,
          data: {
            key: AlertsPageConfigKeyEnum.Postponed
          }
        },
      ],
    },
  ];
}
